import { IAttrValue } from "@multiweb/types/contracts";
import { Localization } from "../../../../OW.Remoting/Remoting/Localization";
import { FileColumn } from "../../../UI/UI/XGControls/Frames/ColumnTemplates/FileColumn";
import { LovColumn } from "../../../UI/UI/XGControls/Frames/ColumnTemplates/LOVColumn";
import { Column } from "../Columns/Column";
import { FlagColumn } from "../Columns/FlagColumn";
import { FlagTemplates } from "./DataTypeTemplates/FlagTemplates";
import { ItemTemplate } from "./ItemTemplate";
/**
 * Template pro vykreslení a naformátování dat do grupovacího stromu. Vzhledem k pevnému svázání stromu s konkrétním seznamem využívá jeho funckionality k formátování dat.
 */
export class GroupingTemplate extends ItemTemplate {
    /**
     * Sloupec navázaného seznamu, který bude provádět formátování právě načtených dat.tree-view-datarow
     */
    public formattingColumn: Column;

    /**
     * Nastaví data do buňky
     * @param dataSet Data ke zobrazení
     * @param item Buňka seznamu
     */
    public override async updateData(dataSet: IAttrValue[], item: HTMLElement): Promise<void> {
        if (dataSet[0] == null) {
            Localization.addLocData(item, "GUI-664883"); // (Prázdné)

            return;
        }

        if (this.formattingColumn && this.formattingColumn.itemTemplate &&
            !(this.formattingColumn instanceof FileColumn || this.formattingColumn instanceof LovColumn)) {
            if (this.formattingColumn instanceof FlagColumn) {
                (this.formattingColumn.itemTemplate as FlagTemplates).updateData(dataSet, item, true);
            } else {
                this.formattingColumn.itemTemplate.updateData(dataSet, item);
            }

            return;
        }

        super.updateData(dataSet, item);
    }
}
